import { AdjustedTime } from "model/Match/AdjustedTime";

export type TimeAttackRoundWeighting = {
  endRoundNum: number | undefined;
  startRoundNum: number;
  order: TimeAttackRoundWeightingOrder;
  weightings: number[];
};

export type TimeAttackRoundWeightingOrder = "Best" | "Serial";

export const isTimeAttackRoundWeightingOrder = (
  value: string
): value is TimeAttackRoundWeightingOrder => {
  return ["Best", "Serial"].includes(value);
};

const getRelevantRoundTimes = (
  weighting: TimeAttackRoundWeighting,
  roundTimes: (AdjustedTime | undefined)[]
) => {
  const startIdx = weighting.startRoundNum - 1;
  const endRoundNum = weighting.endRoundNum ?? weighting.startRoundNum;
  const endIdx = endRoundNum;
  return roundTimes.slice(startIdx, endIdx);
};

const orderTimes = (
  times: (AdjustedTime | undefined)[],
  order: TimeAttackRoundWeightingOrder
) => {
  if (order === "Best") {
    return times.sort((a, b) => {
      if (!a) {
        return 1;
      }

      if (!b) {
        return -1;
      }

      return a.time - b.time;
    });
  }

  return times;
};

export const getTimeAttackRoundTimesWithWeighting = (
  times: (AdjustedTime | undefined)[],
  weighting: TimeAttackRoundWeighting
): { weighting: number; roundTime: AdjustedTime | undefined }[] => {
  const weightingTimes = getRelevantRoundTimes(weighting, times);
  const orderedTimes = orderTimes(weightingTimes, weighting.order);

  return weighting.weightings.map((w, idx) => {
    return { weighting: w, roundTime: orderedTimes[idx] };
  });
};
